import Index from './index/index.vue'
export default {
  Index
}
